import "core-js/modules/es.string.search";
import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(corporateOnEnterSaga);

import { parse as parseQueryString } from 'querystring';
import { call } from 'redux-saga/effects';
import { writeLocalStorage } from 'redux/saga/helpers/local-storage';
import { CORPORATE_PARTNER_STORAGE_KEY } from 'constants/corporate';
import { parseCorporatePartnerPath } from 'helpers/corporate';
export function corporateOnEnterSaga(client, nextState) {
  var corporatePartner, query, corporatePartnerObj;
  return regeneratorRuntime.wrap(function corporateOnEnterSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          corporatePartner = parseCorporatePartnerPath(nextState.params.corporatePartner);
          query = parseQueryString((nextState.location.search || '').substr(1));
          corporatePartnerObj = {
            partner: corporatePartner,
            token: query.token ? query.token : 'unknown',
            initial_url: nextState.location.pathname,
            created: new Date()
          };
          _context.next = 5;
          return call(writeLocalStorage, CORPORATE_PARTNER_STORAGE_KEY, corporatePartnerObj);

        case 5:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}